import React, { useState, useContext, useEffect } from "react";
import "./checkout.css"
import { Context } from "../../app";
import nexum from "../../assets/shop/orbitShop.png"
import nexumMini from "../../assets/shop/orbitMiniShop.png"
import { Mixpanel } from "../../Mixpanel";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Payment from "../../components/payment/payment"
import CartReminder from "../../components/cartReminder/cartReminder";
import Image from "../../components/Image/image";

function Checkout(props) {
    
    const [expanded, setExpanded] = useState(false)
    const [emailReminder, setEmailReminder] = useState(false)
    const [email, setEmail] = useState(localStorage.getItem("email")?localStorage.getItem("email"):"")
    const [error, setError] = useState(false)

    const shop = useContext(Context)
    let navigate = useNavigate()

    useEffect(()=>{
        shop.setStage(2)
        window.scroll({
            top:0,
            left:0
        })
        shop.setShowNav(false)
    },[])

    useEffect(()=>{

    },[])

    useEffect(()=>{
        shop.setShowCart(false)
        shop.setShowPages(false)
        if (shop.mpid) {
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"Checkout",
                    properties:{
                        cart:shop.cart,
                        email:localStorage.getItem("email")?localStorage.getItem("email"):""
                    },
                    id:shop.mpid
                }
            }).then((res)=>{

            })
            .catch((e)=>console.log(e))
        }
        shop.ReactPixel.track("InitiateCheckout", {
            cart:shop.cart
        })
    }, [])

    const changeEmail = (ev)=>{
        if (ev.target.value) {
            setError(false)
        }
        setEmail(ev.target.value)
        localStorage.setItem("email", ev.target.value)
    }

    const decideCheckout = ()=>{
        if (email) {
            setError(false)
            setEmailReminder(false)
            if (shop.mpid) {
                axios({
                    url:shop.url+"mixpanel",
                    method:"POST",
                    headers:{"Content-Type":"application/json"},
                    data:{
                        event:"emailReminder",
                        properties:{
                            email:email
                        },
                        id:shop.mpid
                    }
                }).then((res)=>{
    
                })
                .catch((e)=>console.log(e))
            }
        }
        else {
            setError(true)
        }
    }

    useEffect(()=>{

        let checkoutItems = document.querySelector(".checkout-items")
        let icon = document.querySelector(".item-details-icon")

        if (getComputedStyle(document.querySelector(".checkout-items-title")).display !== "none") {
            if (!expanded) {
                // console.log("clicked", checkoutItems.style.maxHeight)
                checkoutItems.style.maxHeight="50px"
                checkoutItems.style.paddingTop = "0px"
                // icon.style.transform = "rotate(0)"
            }
            else {
                // console.log("what")
                checkoutItems.style.maxHeight="500px"
                checkoutItems.style.paddingTop = "80px"
                // icon.style.transform = "rotate(180deg)"
            }
        }
    }, [expanded])

    function changeHeight() {
        
        let checkoutItems = document.querySelector(".checkout-items")
        let icon = document.querySelector(".item-details-icon")
        
        checkoutItems.style.maxHeight = checkoutItems.style.maxHeight==="100vh"?"50px":"100vh" 
        
        if (checkoutItems.style.maxHeight==="100vh") {
            
        }
        else {
            
        }
        
    }

    return(
        <div className="checkout">
            {/* <h1>Checkout</h1> */}
            {/* {
                emailReminder?
                <CartReminder 
                    email={email}
                    setEmail={setEmail}
                    changeEmail={changeEmail}
                    error = {error}
                    blockout = {true}
                    setEmailReminder={setEmailReminder}
                    decideCheckout={decideCheckout}
                />:""
            } */}
            <div className="checkout-nav">
                <img src="logoTextWhite.png" width={"200px"} alt="" />
                <p onClick={()=>navigate("/")}><i className="material-icons">arrow_back</i>Back</p>
            </div>
            <div className="checkout-content">
                <Payment 
                    email={email}
                    setEmail={setEmail}
                />
                <div  className="checkout-items">
                    <p onClick={()=>setExpanded(!expanded)} className="checkout-items-title">
                        <i className="material-icons-outlined">shopping_cart</i> 
                        <p></p>{expanded?"Hide":"Show"} order summary 
                        <i className="material-icons item-details-icon">{expanded?"expand_less":"expand_more"}</i>
                        <p className="prices">
                            <s>${shop.sanitizeNumber(shop.total)}</s> 
                            ${shop.sanitizeNumber(shop.discount)}
                        </p>
                        {/* <span>${shop.sanitizeNumber(shop.total)}</span> */}
                    </p>
                    {
                        shop.cart.map((item, index)=>{
                            return(
                                <div key={"checkout-page-item"+index} className="checkout-page-item">
                                    <div className="checkout-page-item-pic">
                                        {
                                            <Image 
                                                width={item.id.includes("BUN")?"80%":"100%"}
                                                src={`products/${item.id}.png`}
                                            />
                                        }
                                        <p>{item.quantity}</p>
                                    </div>
                                    <div className="checkout-page-item-details">
                                        <p style={{color:"black"}}>{item.name}</p>
                                        <div className="edit-quantity">
                                            <i style={{color:"gray"}} onClick={()=>shop.removeCart(item.id)} className="material-icons">remove</i>
                                            <p style={{color:"gray"}}>{item.quantity}</p>
                                            <i style={{color:"gray"}} onClick={()=>shop.addCart(item.id, null, null, null)} className="material-icons">add</i>
                                        </div>
                                        
                                    </div>
                                    <p className="item-total">
                                    <s>${shop.sanitizeNumber(item.quantity*item.price)}</s> ${shop.sanitizeNumber(item.discount*item.quantity)}
                                    </p>
                                </div>
                                
                            )
                        })
                    }
                    
                    <div className="checkout-items-total">
                        <p className="items-total-text">Total</p>
                        <p className="items-total">USD <s>${shop.sanitizeNumber(shop.total)}</s> <span>${shop.sanitizeNumber(shop.discount)}</span></p>
                    </div>
                    
                </div>
            </div>
            
            
            
            
            
        </div>
    )
}

export default Checkout